import { FixedBookingDetailsInvoice } from 'features/bookings';
import { useParams } from 'react-router-dom';

export const RecurringBookingInvoiceView = () => {
  const { id } = useParams();

  if (!id) return null;

  return <FixedBookingDetailsInvoice bookingId={id} />;
};
